module.exports = __webpack_public_path__ + "static_portal/img/classic_style_profile.29ad2797.jpg";